import { render } from "./EditAttachmentModal.vue?vue&type=template&id=00a26785&scoped=true"
import script from "./EditAttachmentModal.vue?vue&type=script&lang=js"
export * from "./EditAttachmentModal.vue?vue&type=script&lang=js"

import "./EditAttachmentModal.vue?vue&type=style&index=0&id=00a26785&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a26785"]])

export default __exports__